import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    event.preventDefault()
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.sourceTarget.value)
        .then(() => {
          event.currentTarget.textContent = "Copied!"
        })
        .catch(err => {
          console.error("Failed to copy text: ", err)
        })
    } else {
      console.warn("Clipboard API not supported")
      // Fallback for browsers that do not support the Clipboard API
      const textArea = document.createElement("textarea")
      textArea.value = this.sourceTarget.value
      document.body.appendChild(textArea)
      textArea.select()
      try {
        document.execCommand("copy")
        event.currentTarget.textContent = "Link kopiert!"
      } catch (err) {
        console.error("Failed to copy text (fallback): ", err)
      } finally {
        document.body.removeChild(textArea)
      }
    }
  }
}
